"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FormError_1 = __importDefault(require("../FormError"));
var SelectFieldMultiValue_1 = __importDefault(require("./SelectFieldMultiValue"));
var SelectFieldOptions_1 = __importDefault(require("./SelectFieldOptions"));
var fuzzyFilter_1 = __importDefault(require("./fuzzyFilter"));
var SelectFieldMulti = /** @class */ (function (_super) {
    __extends(SelectFieldMulti, _super);
    function SelectFieldMulti(props) {
        var _this = _super.call(this, props) || this;
        _this.getValue = function () {
            var _a = _this.props, name = _a.name, value = _a.value, values = _a.values;
            if (value !== undefined) {
                return value;
            }
            var passed = values[name];
            if (passed !== undefined) {
                return passed;
            }
            return null;
        };
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        _this.handleWindowClick = function (event) {
            var _a = _this.props, createClickNeeded = _a.createClickNeeded, onCloseAction = _a.onCloseAction, selectRef = _a.selectRef, onFocus = _a.onFocus;
            if (event.target) {
                if (event.target.id === "sl-placeholder" || event.target.id === "create-field-option") {
                    return;
                }
            }
            var _b = _this.state, display = _b.display, open = _b.open;
            var select = selectRef.current;
            var normal = _this.getValue();
            if (open && select && event.target instanceof Element && !select.contains(event.target)) {
                if (createClickNeeded) {
                    _this.selectValue(_this.getValue(), true);
                }
                else if (display && display.length > 0) {
                    var nextValue = [];
                    nextValue = normal
                        ? __spreadArrays(normal.filter(function (item) { return item !== display; }), [display]) : [display];
                    onFocus();
                    _this.selectValue(nextValue, false);
                    _this.propagateValue(nextValue);
                }
                if (onCloseAction) {
                    onCloseAction();
                }
            }
        };
        _this.handleSelect = function (selected, category) {
            if (category === void 0) { category = ""; }
            var onFocus = _this.props.onFocus;
            var normal = _this.getValue();
            var nextValue = [];
            if (category.length > 0) {
                nextValue = normal
                    ? __spreadArrays(normal.filter(function (item) { return item !== selected; }), [{ value: selected, category: category }]) : [{ value: selected, category: category }];
            }
            else {
                nextValue = normal
                    ? __spreadArrays(normal.filter(function (item) { return item !== selected; }), [selected]) : [selected];
            }
            onFocus();
            _this.selectValue(nextValue, false);
            _this.propagateValue(nextValue);
        };
        _this.handleDeselect = function (deselected, category) {
            if (category === void 0) { category = ""; }
            var onFocus = _this.props.onFocus;
            var placeholderIsVisible = _this.state.placeholderIsVisible;
            var normal = _this.getValue();
            var nextValue = null;
            if (category.length > 0) {
                nextValue = normal
                    ? normal.filter(function (item) { return (item.value !== deselected); })
                    : null;
            }
            else {
                nextValue = normal ? normal.filter(function (item) { return item !== deselected; }) : null;
            }
            if (!placeholderIsVisible) {
                onFocus();
            }
            _this.selectValue(nextValue, false);
            _this.propagateValue(nextValue);
        };
        _this.handleChange = function (event) {
            var _a = _this.props, allWordsMatch = _a.allWordsMatch, onTextChanged = _a.onTextChanged, options = _a.options;
            var nextDisplay = event.target.value;
            if (onTextChanged) {
                onTextChanged(nextDisplay);
            }
            _this.setState({
                display: nextDisplay || "",
                filteredOptions: fuzzyFilter_1.default(options, nextDisplay, allWordsMatch),
                open: true
            });
        };
        _this.handleOpen = function () {
            var onFocus = _this.props.onFocus;
            onFocus();
            _this.setState({ open: true });
        };
        _this.handleClose = function () {
            _this.setState({ open: false, touched: true });
        };
        _this.handleInputFocus = function () {
            var placeholderIsVisible = _this.state.placeholderIsVisible;
            var onSelected = _this.props.onSelected;
            if (onSelected) {
                onSelected();
            }
            _this.inputFocusClass(true);
            if (!placeholderIsVisible)
                return;
            _this.inputFocusClass(true);
            _this.setState(function (prev) { return (__assign(__assign({}, prev), { placeholderIsVisible: false })); });
        };
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        _this.handleInputBlur = function (event) {
            var placeholderIsVisible = _this.state.placeholderIsVisible;
            var onUnselected = _this.props.onUnselected;
            if (onUnselected) {
                onUnselected();
            }
            var shouldShowPlaceholder = !event.relatedTarget
                || (event.relatedTarget.id !== "select-field-option" && event.relatedTarget.id !== "option-tag"
                    && event.relatedTarget.id !== "option-action" && event.relatedTarget.id !== "create-field-option");
            if (placeholderIsVisible === shouldShowPlaceholder)
                return;
            if (event.relatedTarget) {
                if (event.relatedTarget.id) {
                    if (!(event.relatedTarget.id === "select-field-option" || event.relatedTarget.id === "option-tag" || event.relatedTarget.id === "create-field-option")) {
                        _this.inputFocusClass(false);
                        _this.setState(function (prev) { return (__assign(__assign({}, prev), { placeholderIsVisible: true })); });
                    }
                }
                else {
                    _this.inputFocusClass(false);
                    _this.setState(function (prev) { return (__assign(__assign({}, prev), { placeholderIsVisible: true })); });
                }
            }
            else {
                _this.inputFocusClass(false);
                _this.setState(function (prev) { return (__assign(__assign({}, prev), { placeholderIsVisible: true })); });
            }
        };
        _this.inputFocusClass = function (focused) {
            var inputRef = _this.props.inputRef;
            if (inputRef.current) {
                if (focused) {
                    inputRef.current.classList.add("chq-ffd--sl--match__focus");
                }
                else {
                    inputRef.current.classList.remove("chq-ffd--sl--match__focus");
                }
            }
        };
        _this.propagateValue = function (value) {
            var _a = _this.props, name = _a.name, onChange = _a.onChange, onFormChange = _a.onFormChange;
            if (onChange) {
                onChange(value);
            }
            onFormChange(name, value);
        };
        _this.selectValue = function (nextValue, shouldClose) {
            var options = _this.props.options;
            _this.setState(function (prevState) { return ({
                display: "",
                touched: true,
                open: shouldClose ? false : prevState.open
            }); }, function () {
                if (_this.timeout) {
                    clearTimeout(_this.timeout);
                    _this.timeout = null;
                }
                _this.timeout = window.setTimeout(function () {
                    _this.setState({ filteredOptions: options });
                    _this.timeout = null;
                }, 150);
            });
        };
        _this.state = {
            display: "",
            filteredOptions: props.options,
            open: false,
            touched: false,
            placeholderIsVisible: props.placeholder !== "" && !props.removePlacholder
        };
        _this.timeout = null;
        return _this;
    }
    SelectFieldMulti.prototype.componentDidMount = function () {
        window.addEventListener("click", this.handleWindowClick);
    };
    SelectFieldMulti.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, allWordsMatch = _a.allWordsMatch, initialDisplay = _a.initialDisplay, options = _a.options;
        var _b = this.state, display = _b.display, open = _b.open, placeholderIsVisible = _b.placeholderIsVisible, touched = _b.touched;
        if (prevProps.options !== options) {
            this.setState({
                display: initialDisplay || "",
                filteredOptions: fuzzyFilter_1.default(options, display, allWordsMatch)
            });
        }
        if (!open && !prevState.open && !placeholderIsVisible) {
            if (touched) {
                this.inputFocusClass(false);
                var autoFocus = this.props.autoFocus;
                if (!autoFocus) {
                    this.setState({
                        placeholderIsVisible: true
                    });
                }
                else {
                    this.inputFocusClass(true);
                }
            }
        }
    };
    SelectFieldMulti.prototype.componentWillUnmount = function () {
        window.removeEventListener("click", this.handleWindowClick);
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    };
    /* eslint-disable jsx-a11y/label-has-for */
    // we're following the rules for it but it can't figure that out
    SelectFieldMulti.prototype.render = function () {
        var _a = this.props, allowEmpty = _a.allowEmpty, ariaLabel = _a.ariaLabel, creatable = _a.creatable, creatableLabel = _a.creatableLabel, disabled = _a.disabled, imageIconPath = _a.imageIconPath, inputRef = _a.inputRef, name = _a.name, onError = _a.onError, options = _a.options, placeholder = _a.placeholder, onSelected = _a.onSelected, onUnselected = _a.onUnselected, required = _a.required, selectRef = _a.selectRef, submitted = _a.submitted, validator = _a.validator, removePlacholder = _a.removePlacholder;
        var _b = this.state, display = _b.display, filteredOptions = _b.filteredOptions, open = _b.open, touched = _b.touched, placeholderIsVisible = _b.placeholderIsVisible;
        var normal = this.getValue();
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { ref: selectRef, className: "chq-ffd--sl" },
                react_1.default.createElement(SelectFieldMultiValue_1.default, { ariaLabel: ariaLabel, disabled: disabled, display: display, imageIconPath: imageIconPath, inputRef: inputRef, name: name, onChange: this.handleChange, onClose: this.handleClose, onDeselect: this.handleDeselect, onSelected: onSelected, onUnselected: onUnselected, onOpen: this.handleOpen, open: open, options: options, placeholder: placeholder, value: normal, removePlacholder: removePlacholder, placeholderIsVisible: placeholderIsVisible, onInpuFocus: this.handleInputFocus, onInputBlur: this.handleInputBlur }),
                react_1.default.createElement(SelectFieldOptions_1.default, { allowEmpty: allowEmpty, creatable: creatable, creatableLabel: creatableLabel, display: display, filteredOptions: filteredOptions, multiple: true, onDeselect: this.handleDeselect, onSelect: this.handleSelect, open: open, options: options, value: normal })),
            react_1.default.createElement(FormError_1.default, { name: name, onError: onError, required: required, submitted: submitted, touched: touched, validator: validator, value: normal })));
    };
    return SelectFieldMulti;
}(react_1.default.Component));
exports.default = SelectFieldMulti;
